export default __webpack_public_path__ + "tmp_src/components/MainNavigation/MainNavigation.css.liquid";